// ---------------------------------------------------------------------------
// The card. A view is allowed two backgrounds, so a card is `surface` on `bg`
// and a nested row inside it is `surface-2`, never a third tone.
// ---------------------------------------------------------------------------

import type { ReactElement, ReactNode } from 'react';

export function Card({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}): ReactElement {
  return (
    <div className={`rounded-frame border border-line bg-surface p-5 ${className ?? ''}`}>{children}</div>
  );
}

export function CardTitle({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}): ReactElement {
  return (
    <h2 className={`text-[24px] leading-none font-bold ${className ?? ''}`} style={{ letterSpacing: '-0.01em' }}>
      {children}
    </h2>
  );
}
